var _defs, _rect, _polygon, _path, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTamuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#500000;}.cls-2{fill:#fff;}.cls-3{fill:#b1b3b6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.17,
    y: 36.16,
    width: 180,
    height: 181.43
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.27 108.37 178.9 108.37 178.13 108.37 177.78 109.07 168.09 129.25 158.36 109.06 158.02 108.37 157.25 108.37 144.33 108.37 143.11 108.37 143.11 109.6 143.11 116.48 143.11 117.71 144.33 117.71 146.54 117.71 146.54 146.61 144.15 146.61 142.92 146.61 142.92 147.84 142.92 154.72 142.92 155.95 144.15 155.95 158.66 155.95 159.89 155.95 159.89 154.72 159.89 147.84 159.89 146.61 158.66 146.61 156.15 146.61 156.15 126.1 166.99 148.45 168.09 150.73 169.21 148.45 180.16 126.05 180.16 146.61 177.77 146.61 176.53 146.61 176.53 147.84 176.53 154.72 176.53 155.95 177.77 155.95 192.27 155.95 193.5 155.95 193.5 154.72 193.5 147.84 193.5 146.61 192.27 146.61 189.77 146.61 189.77 117.71 192.27 117.71 193.5 117.71 193.5 116.48 193.5 109.6 193.5 108.37 192.27 108.37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108,146.58h-3.86l-12.56-29H94V108.2H73.84v9.35h2.78l-12.55,29H58.84v9.35h18.3v-9.35H74.48l2.09-4.83h15.1l2.08,4.83H90.94v9.35h18.31v-9.35ZM87.62,132.41h-7l3.5-8.11Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "176.91 72.08 75.1 72.08 73.69 72.08 73.69 73.49 73.69 100.69 73.69 102.1 75.1 102.1 92.68 102.1 94.09 102.1 94.09 100.69 94.09 90.59 115.81 90.59 115.81 162.26 105.7 162.26 104.3 162.26 104.3 163.67 104.3 181.25 104.3 182.66 105.7 182.66 146.3 182.66 147.71 182.66 147.71 181.25 147.71 163.67 147.71 162.26 146.3 162.26 136.21 162.26 136.21 90.59 157.8 90.59 157.8 100.56 157.8 101.97 159.21 101.97 176.91 101.97 178.32 101.97 178.32 100.56 178.32 73.49 178.32 72.08 176.91 72.08"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "139.22 170.63 143.52 166.2 143.52 178.34 139.22 174.23 139.22 170.63"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.06 166.52 127.75 170.76 127.75 82.14 132.06 86.43 132.06 166.52"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.31 80.58 77.89 76.28 171.98 76.28 166.42 80.58 82.31 80.58"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "174.26 98.03 169.96 93.92 169.96 82.98 174.26 78.56 174.26 98.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.57,214a3.61,3.61,0,1,1,3.61,3.61A3.61,3.61,0,0,1,222.57,214Zm6.34,0a2.73,2.73,0,1,0-2.73,2.91A2.77,2.77,0,0,0,228.91,214Zm-4.12-2.06h1.52c1,0,1.51.34,1.51,1.2a1,1,0,0,1-1.07,1.1l1.1,1.79h-.78L226,214.25h-.46V216h-.76Zm.76,1.75h.67c.45,0,.84-.06.84-.61s-.44-.56-.83-.56h-.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamuLogo);
export default __webpack_public_path__ + "static/media/TAMULogo.4445ab5e7e934678f12bad06f06e0498.svg";
export { ForwardRef as ReactComponent };